/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ExecRiskValidationError
 */
export interface ExecRiskValidationError {
    /**
     * 
     * @type {number}
     * @memberof ExecRiskValidationError
     */
    status: number;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskValidationError
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskValidationError
     */
    message: string;
}

/**
 * Check if a given object implements the ExecRiskValidationError interface.
 */
export function instanceOfExecRiskValidationError(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "status" in value;
    isInstance = isInstance && "title" in value;
    isInstance = isInstance && "message" in value;

    return isInstance;
}

export function ExecRiskValidationErrorFromJSON(json: any): ExecRiskValidationError {
    return ExecRiskValidationErrorFromJSONTyped(json, false);
}

export function ExecRiskValidationErrorFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExecRiskValidationError {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': json['status'],
        'title': json['title'],
        'message': json['message'],
    };
}

export function ExecRiskValidationErrorToJSON(value?: ExecRiskValidationError | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
        'title': value.title,
        'message': value.message,
    };
}

